/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Translations,
  checkBoolean,
  convertStringToArrayForRadio,
  isEmptyObject,
  savePageStateInSessionStorage
} from '../../../../utils';

//action Creator
import { blockUi, unBlockUi } from '../../../../actions/actionCreator';
import {
  resetCashFlowForecastingActiveTabIndex,
  resetCurrentProductCashFlowForecasting,
  setAddresses,
  setCaptureProductCashFlowForecasting,
  setCashFlowForecastingActiveTabIndex,
  setPersons
} from '../../actions/actionCreator';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';

import NavListAccordionWrapper from '../../../common/CashFlowForecastingAccordion/cashFlowForecastingAccordion';


//styles
import { FORM_REFS } from '../../../../constants';
import DynamicForm from '../../../common/Dynamicform/dynamicForm';
import MultiLineSelect from '../../../common/MultiLineSelect';
import NavListAccordion from '../../../common/NavListAccordion/NavListAccordion';
import PersistLink from '../../../common/PersistLink';
import RadioButton from '../../../common/Radio/radioButton';
import './styles.css';


class CaptureProductCashFlowForecasting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      basicDetailsFormJson: {}, eChannelReportingPageJson: {}, pageJson: {}, countryTaxonomyList: [], eChannelReportingList: [], reportToEChannel: "", selectedEChannel: {}
    }
  }

  componentDidMount() {
    this.props.blockUi();
    this.loadPageState();
    this.props.unBlockUi();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      if (nextProps.lang.currentLang.lang === 'Spanish') {
        this.getCashFlowForecastingTaxonomy('ES');
      } else if (nextProps.lang.currentLang.lang === 'Bahasa') {
        this.getCashFlowForecastingTaxonomy('BA');
      } else {
        this.getCashFlowForecastingTaxonomy('EN');
      }
      this.getCountryTaxonomy();
    }
  }

  loadPageState = () => {
    const { productId, caseId } = this.props.match.params;
    aemHostClient("/aemData/formData/json_cash-flow-forecasting-all-closed")
      .then(({ data }) => {
        if (!isEmptyObject(data.par)) {
          this.setState({ pageJson: data.par }, () => {
            this.getCashFlowForecastingTaxonomy()
          })
        }
      });

    aemHostClient("/aemData/formData/json_cff-echannel-reporting-accordian-page")
      .then(({ data }) => {
        if (!isEmptyObject(data.par)) {
          this.setState({ eChannelReportingPageJson: data.par });
        }
      });

    this.getCashFlowForecastingProductAccordionStatus()
    this.saveCashFlowForecastingProductDetails({}, this.getCashFlowForecastingEChannelList)
  }

  getCashFlowForecastingProductAccordionStatus = () => {
    const { productId } = this.props.match.params;
    eapiClient("/product/cff/" + productId + "/status")
      .then(({ data }) => {
        if (!isEmptyObject(data.responseData)) {
          this.setState({ status: data.responseData });
          this.props.setCaptureProductCashFlowForecasting({ accordionStatus: data.responseData });
        }
      });
  }

  saveCashFlowForecastingProductDetails = (options, callback) => {
    const { productId } = this.props.match.params;
    let apiUrl = "/product/cff/" + productId
    let payload = {}
    if (!isEmptyObject(options)) {
      const { method, data } = options
      if (method && data) {
        payload = {
          method, data
        }
      }
    }
    eapiClient(apiUrl, payload)
      .then(({ data }) => {
        if (!isEmptyObject(data.responseData)) {
          this.props.setCaptureProductCashFlowForecasting({ data: data.responseData });
          if (data.responseData.reportToEchannel !== undefined) {
            this.setShouldReportToEchannel(data.responseData.reportToEchannel ? "true" : "false")
          }
          if (typeof callback === "function") {
            callback(data.responseData)
          } else {
            this.getCashFlowForecastingProductAccordionStatus()
          }
        }
      })
  }

  getChannelID = (channelList) => {
    const isRedirectChannelId = this.props.currentProductCashFlowForecasting.selectedEChannelId
    return ({
      eChannelId: isRedirectChannelId ? isRedirectChannelId : Array.isArray(channelList) && channelList.length && channelList[0], isRedirect: Boolean(isRedirectChannelId)
    })
  }

  getCashFlowForecastingEChannelList = (productData) => {
    const { country, cffAgent, eChannelReporting } = productData
    if (country && cffAgent) {
      const { caseId } = this.props.match.params;
      const eChannelListApiUrl = `/product/echannel/case/cff/${caseId}/${country.name}/${encodeURIComponent(cffAgent.name)}`
      eapiClient(eChannelListApiUrl)
        .then(({ data }) => {
          if (Array.isArray(data.responseData) && data.responseData.length) {
            const { eChannelId, isRedirect } = this.getChannelID(eChannelReporting)
            if (eChannelId) {
              const selectedEChannelObject = data.responseData.find(eChannel => eChannel.id === eChannelId)
              if (!isEmptyObject(selectedEChannelObject)) {
                this.handleEChannelReportingDetails({ selectedEChannel: selectedEChannelObject, selectedEChannelId: null })
              }
            }
            this.handleEChannelReportingDetails({ eChannelReportingList: data.responseData })
          }
        });
    }
  }





  getCashFlowForecastingTaxonomy = (lang = "ENG") => {
    const countryTaxonomyApiUrl = this.state.pageJson.aemform_basicDetails && this.state.pageJson.aemform_basicDetails.ccTaxonomy
    if (countryTaxonomyApiUrl) {
      eapiClient(this.getTranslated(countryTaxonomyApiUrl))
        .then(({ data }) => {
          if (data.responseData && data.responseData.classificationNodes) {
            this.setState({
              countryTaxonomyList: data.responseData.classificationNodes
            })
          }
        });
    }
  }

  getCountryTaxonomy = () => {
    if (this.state.pageJson.aemform_eChannelReporting && this.state.pageJson.aemform_eChannelReporting.countryTaxonomy)
      taxonomyHostClient(this.getTranslated(this.state.pageJson.aemform_eChannelReporting.countryTaxonomy))
        .then(({ data }) => {
          if (data.responseData !== undefined) {
            let currentListCountries = data.responseData.classificationNodes;
            let val = this.state.country ? this.state.country.value : '';
            if (val !== undefined && currentListCountries !== undefined) {
              let countryItem = currentListCountries.find(x => x.id === val);
              if (countryItem !== undefined) {
                let countryName = countryItem.name;
                this.setState({ countryName });
              }
            }
          }
        });
  }



  saveStateToSessionOnEdit = () => {
    savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
  }

  // set accordion index
  getTabIndex = (index) => {
    if (!(index === this.props.activeTabIndex))
      this.props.setCashFlowForecastingActiveTabIndex(index);
  }

  getBasicDetails = (data) => {
    this.setState({ basicDetail: data });
  }

  renderBasicDetailsForm = () => {
    const { formRef } = this.state.pageJson.aemform_basicDetails;
    const apiUrl = typeof formRef === "string" && formRef && FORM_REFS[formRef]
    if (apiUrl) {
      const { cffAgent, country } = this.props.currentProductCashFlowForecasting.data ? this.props.currentProductCashFlowForecasting.data : {}
      const properties = {
        productId: this.props.match.params.productId,
        formData: {
          cffEntity: cffAgent,
          cffCountry: country
        },
        country: this.props.currentProductCashFlowForecasting.data && this.props.currentProductCashFlowForecasting.data.country && this.props.currentProductCashFlowForecasting.data.country.name,
        editType: 'capture-product-cff-basic-details',
        pathname: this.props.history.location.pathname
      };
      return (
        <DynamicForm mode="edit"
          properties={properties}
          hideButtons={true}
          saveButton={true}
          onFormSubmit={(value) => { return value }}
          getFormData={this.getBasicDetails}
          history={this.props.history}
          url={apiUrl}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
          productType="capture-cash-flow-forecasting-basic-details"
        />
      );
    }
  }

  translateWordForRadio = (word) => {
    var currentWord = this.getTranslated(word)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  getTranslated = (value) => {
    return Translations(value, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  setShouldReportToEchannel = (value) => {
    if (checkBoolean(value)) {
      this.handleEChannelReportingDetails({ reportToEChannel: value, })
    } else {
      this.handleEChannelReportingDetails({
        selectedEChannel: {},
        reportToEChannel: value,
      })
    }
  }

  handleEChannelReportingDetails = (data = {}) => {
    this.props.setCaptureProductCashFlowForecasting({
      eChannelReportingDetails: {
        ...this.props.currentProductCashFlowForecasting.eChannelReportingDetails,
        ...data,
      }
    });
  }

  getEChannelReportingDetails = (value) => {
    return this.props.currentProductCashFlowForecasting.eChannelReportingDetails[value]
  }

  handleCashFlowForecastingEChannelReportingChange = (index, selectedEChannel) => {
    this.handleEChannelReportingDetails({ selectedEChannel: selectedEChannel })

  }

  handleCashFlowForecastingEChannelReportingSubmit = (saveAndReturn) => {
    const data = JSON.stringify({
      product: {
        productType: "cff",
        eChannelReporting: !isEmptyObject(this.getEChannelReportingDetails("selectedEChannel")) && checkBoolean(this.getEChannelReportingDetails("reportToEChannel")) ? [this.getEChannelReportingDetails("selectedEChannel").id] : [],
        reportToEchannel: this.props.currentProductCashFlowForecasting.eChannelReportingDetails.reportToEChannel === "" ? undefined : checkBoolean(this.getEChannelReportingDetails("reportToEChannel"))
      }
    })
    const options = {
      method: "PUT", data
    }
    this.saveCashFlowForecastingProductDetails(options, saveAndReturn && this.handleSaveAndReturn)

  }

  handleSaveAndReturn = () => {
    this.props.history.goBack()
    this.props.resetCashFlowForecastingActiveTabIndex()
    this.props.resetCurrentProductCashFlowForecasting()
  }

  getCffeChannelReportingsJsx = () => {
    let eChannelReportingsJsx = []
    for (let i = 1; i <= this.getEChannelReportingDetails("eChannelReportingList").length + 1; i++) {
      eChannelReportingsJsx.push(
        <div className="echannel-list" key={"eChannelReporting" + i}>
          <div className="list-text">
            <label for={`Echannel${i}`}>
              {this.getTranslated(this.state.eChannelReportingPageJson.static_text_cffechannelReporting.echannel)}
            </label>
          </div>
          <div className="list-option">
            {
              this.getEChannelReportingDetails("eChannelReportingList").length > 0 && !isEmptyObject(this.state.eChannelReportingPageJson) ?
                (
                  <MultiLineSelect defaultValue={this.state.eChannelReportingPageJson !== undefined ? this.getTranslated(this.state.eChannelReportingPageJson.static_text_pleaseSelect.text) : ''}
                    id={`Echannel${i}`}
                    requiredFields={{
                      "row1": ["eChannelType", "country"],
                      "row2": ["profileOwner"],
                      "row3": []
                    }}
                    formatters={{
                      "row1": [null, (data, fieldValue) => data.newEchannel ? `${fieldValue} (New)` : `${fieldValue} (Existing)`, null],
                      "row2": [],
                      "row3": []
                    }}
                    data={this.getEChannelReportingDetails("eChannelReportingList")}
                    value={this.getEChannelReportingDetails("selectedEChannel").id ? this.getEChannelReportingDetails("selectedEChannel").id : ''}
                    disabledOptions={this.getEChannelReportingDetails("selectedEChannel").id ? [this.getEChannelReportingDetails("selectedEChannel").id] : []}
                    multiAccount={true}
                    _onChange={this.handleCashFlowForecastingEChannelReportingChange.bind(this, i - 1)} />
                ) : null
            }
            <span className="icon icon-add addicon"></span>
            <PersistLink className="mrg-left"
              to={'/case-body/case-body/create-cash-flow-forecasting-echannel'}
              history={this.props.history}
              state={this.state}
              data={`eChannelReporting${i}`}>
              {this.state.eChannelReportingPageJson !== undefined ? this.getTranslated(this.state.eChannelReportingPageJson.static_text_cffechannelReporting.createText) : ''}
            </PersistLink>
          </div>
        </div>);
      return eChannelReportingsJsx
    }
  }

  shouldRender = () => {
    return !isEmptyObject(this.state.pageJson.aemform_basicDetails) && !isEmptyObject(this.props.currentProductCashFlowForecasting) && !isEmptyObject(this.state.eChannelReportingPageJson)
  }
  renderAccordions = () => {
    return this.shouldRender() ?
      <div>
        <NavListAccordion
          lang={this.props.lang.currentLang.lang}
          navAccHeading={
            this.state.pageJson.aemform_basicDetails && this.state.pageJson.aemform_basicDetails.title ?
              "1. " + this.getTranslated(this.state.pageJson.aemform_basicDetails.title) : "1. Basic Details"
          }
          status={this.props.currentProductCashFlowForecasting.accordionStatus && this.props.currentProductCashFlowForecasting.accordionStatus.basicDetails && this.props.currentProductCashFlowForecasting.accordionStatus.basicDetails.status}
          _onClick={() => this.getTabIndex("0")}
        >
          <div>{this.renderBasicDetailsForm()}</div>
        </NavListAccordion>

        <NavListAccordion
          lang={this.props.lang.currentLang.lang}
          navAccHeading={
            this.state.pageJson.aemform_eChannelReporting && this.state.pageJson.aemform_eChannelReporting.title ?
              "2. " + this.getTranslated(this.state.pageJson.aemform_eChannelReporting.title) : "2. E Channel Reporting"
          }
          status={this.props.currentProductCashFlowForecasting.accordionStatus && this.props.currentProductCashFlowForecasting.accordionStatus.eChannelReporting && this.props.currentProductCashFlowForecasting.accordionStatus.eChannelReporting.status}
          id="eChannel-reporting"
          _onClick={() => this.getTabIndex("1")}
        >
          <div className="echannel-reporting-section">
            <p>
              {this.getTranslated(this.state.eChannelReportingPageJson.static_text_cffechannelReporting.description)}
            </p>
            <div className="gdocs-cff-report-echannel-wrapper">
              <div className="is-echannel-reporting-container">
                <div className="is-report-text">
                  {this.getTranslated(this.state.eChannelReportingPageJson.static_text_cffechannelReporting.reportAccount)}
                </div>
                <div
                  className="is-report-radio-group"
                  role="radiogroup"
                  aria-label={this.getTranslated(this.state.eChannelReportingPageJson.static_text_cffechannelReporting.reportAccount)}
                >
                  <label>
                    {
                      this.translateWordForRadio(this.state.eChannelReportingPageJson.static_text_cffechannelReporting.options)[0].split('=')[1]
                    }
                    <RadioButton
                      setInputvalue={this.setShouldReportToEchannel}
                      name="setShouldReportToEchannel"
                      _value={this.getEChannelReportingDetails("reportToEChannel")}
                      value={true}
                    />
                  </label>
                  <label className="disabled">
                    {
                      this.translateWordForRadio(this.state.eChannelReportingPageJson.static_text_cffechannelReporting.options)[1].split('=')[1]
                    }
                    <RadioButton
                      setInputvalue={this.setShouldReportToEchannel}
                      name="setShouldReportToEchannel"
                      _value={this.getEChannelReportingDetails("reportToEChannel")}
                      value={false}
                    />
                  </label>
                </div>
              </div>
              {checkBoolean(this.getEChannelReportingDetails("reportToEChannel")) && this.state.eChannelReportingPageJson.static_text_cffechannelReporting.helpText &&
                <p className="fs13">{this.getTranslated(this.state.eChannelReportingPageJson.static_text_cffechannelReporting.helpText)}</p>
              }
              {
                checkBoolean(this.getEChannelReportingDetails("reportToEChannel"))
                  ? this.getCffeChannelReportingsJsx()
                  : null
              }
            </div>
            <div className="gdocs-clear-float"></div>
          </div>
          <div className="gdocs-clear-float"></div>
          <div key="buttons-wrapper" className="form-buttons-save-section">
            <div className="form-buttons-wrapper">
              <button className="gdocs-btn-submit" onClick={() => this.handleCashFlowForecastingEChannelReportingSubmit()}>
                {this.getTranslated(this.state.eChannelReportingPageJson.static_text_cffechannelReporting.saveRefresh)}
              </button>
            </div>
          </div>
        </NavListAccordion>

      </div>
      : null
  }

  render() {
    const countryName = this.props.currentProductCashFlowForecasting.data && this.props.currentProductCashFlowForecasting.data.
      country ? this.props.currentProductCashFlowForecasting.data.country.name : ''
    const cffAgentName = this.props.currentProductCashFlowForecasting.data && this.props.currentProductCashFlowForecasting.data.cffAgent ? this.props.currentProductCashFlowForecasting.data.cffAgent.name : ''

    document.title = countryName ? `Product Requests - Review Product - Cash Flow Forecasting - ${this.props.currentProductCashFlowForecasting.data.country.name} - HSBC GLCM` : `Product Requests- HSBC GLCM`

    return (!isEmptyObject(this.state.pageJson)) ?
      <div className="product-cc-container">
        <div className="pannel-heading-container">
          <h2 className="pannel-heading">{countryName}</h2>
          <p className="pannel-sub-heading">{cffAgentName}</p>
          <p className="optional-text">{this.getTranslated(this.state.pageJson.static_text_requiredText.title)}</p>
        </div>
        <div className="gdocs-clear-float">
        </div>
        <NavListAccordionWrapper open={this.props.activeTabIndex}>
          {this.renderAccordions()}
        </NavListAccordionWrapper>
        <div className="btn-wrapper">
          <div className="display-flex-content-end">
            <button onClick={() => this.handleCashFlowForecastingEChannelReportingSubmit(true)} className='gdocs-btn-primary'>
              {this.getTranslated(this.state.pageJson.guidebutton_saveAndReturn.text)}
            </button>
          </div>

        </div>
      </div>
      : null
  }
}

const mapStateToProps = state => ({
  lang: state.lang,
  cases: state.cases,
  currentProductCashFlowForecasting: state.currentProductCashFlowForecasting,
  activeTabIndex: state.currentProductCashFlowForecasting.activeTabIndex
});

const mapDispatchToProps = dispatch => {
  return {
    setCaptureProductCashFlowForecasting: data => {
      dispatch(setCaptureProductCashFlowForecasting(data));
    },
    setAddresses: addresses => {
      dispatch(setAddresses(addresses));
    },
    setPersons: persons => {
      dispatch(setPersons(persons));
    },
    resetCurrentProductCashFlowForecasting: () => {
      dispatch(resetCurrentProductCashFlowForecasting());
    },
    setCashFlowForecastingActiveTabIndex: index => {
      dispatch(setCashFlowForecastingActiveTabIndex(index))
    },
    resetCashFlowForecastingActiveTabIndex: () => {
      dispatch(resetCashFlowForecastingActiveTabIndex())
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CaptureProductCashFlowForecasting);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductCashFlowForecasting/index.js